module.exports = __webpack_public_path__ + "static/img/logo7.81272274.jpg";